module.exports = __webpack_public_path__ + "img/round_corner_card.261de890.png";